import IActivityLogEntry from "../interface/iActivityLogEntry";
import IActivityLogSort, {
  ActivityLogSortColumn,
} from "../interface/iActivityLogSort";
import {
  getActionLabel,
  getActorLabel,
  getAreaLabel,
  getRoleLabel,
  getStatusLabel,
} from "./activityLogLabels";

const collator = new Intl.Collator("de", { sensitivity: "base" });

// Sorting follows what the table shows, so labels are compared, not keys.
const sortValue: Record<
  ActivityLogSortColumn,
  (entry: IActivityLogEntry) => string | null
> = {
  date: (entry) => entry.date,
  actor: (entry) => getActorLabel(entry),
  role: (entry) => getRoleLabel(entry.actorRole),
  area: (entry) => getAreaLabel(entry.area),
  action: (entry) => getActionLabel(entry.action),
  subject: (entry) => entry.subject?.name ?? null,
  status: (entry) => getStatusLabel(entry.status),
};

const compareNullable = (a: string | null, b: string | null): number => {
  if (a === b) return 0;
  if (a === null) return 1;
  if (b === null) return -1;
  return collator.compare(a, b);
};

const sortActivityLog = (
  entries: IActivityLogEntry[],
  sort: IActivityLogSort
): IActivityLogEntry[] => {
  const direction = sort.direction === "asc" ? 1 : -1;
  const valueOf = sortValue[sort.column];

  return [...entries].sort((a, b) => {
    const byColumn = compareNullable(valueOf(a), valueOf(b));

    if (byColumn !== 0) {
      // entries without a value stay last in both directions
      return valueOf(a) === null || valueOf(b) === null
        ? byColumn
        : byColumn * direction;
    }

    return (a.id - b.id) * direction;
  });
};

export default sortActivityLog;
